// Stimulus application — behaviour that belongs to an element lives in a
// controller (data-controller="…") and connects/disconnects with the DOM, so
// it needs no turbo:load hooks or "already bound" markers. New interactive
// pieces go here; the older page entrypoints stay vanilla until they are
// rewritten.
import { Application } from '@hotwired/stimulus'

const application = Application.start()
application.debug = false
window.Stimulus = application

export { application }
